import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router/";
import "./filters/";
import store from "./store/";
import "./registerServiceWorker";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "echarts/dist/echarts-en";
import VueMoment from "vue-moment";
import VeeValidate from "vee-validate";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import i18n from "./lang"; // Internationalization

import "@/assets/style.css";

Vue.use(vueNumeralFilterInstaller, { locale: "en-gb" });
Vue.use(VueMoment);
Vue.use(VeeValidate);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
